import type { NextApiRequest, NextApiResponse } from 'next'
import type {
  CreateOrderRequest,
  CreateOrderResponse,
  IngridCreateSessionResponse,
  Language,
  OldProductDTO,
  StorefrontOrderLine
} from 'ecosystem'
import storefrontApi from 'api/storefront-api'
import { ingridApi } from 'api'
import { DEFAULT_COUNTRY, DEFAULT_CURRENCY, getFullLocale } from 'shared-utils'
import { generateIngridCart } from 'api/utils/indrid/checkout/utils'
import { type ShippingProviderOpts } from '../shippingProviders/types'

export const ingridShippingProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<CreateOrderResponse | { error: string }>,
  opts: ShippingProviderOpts,
  cb: (ingridResponse: IngridCreateSessionResponse) => Promise<void>
) => {
  const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
  const { items, cartDiscountCode }: CreateOrderRequest = JSON.parse(req.body)
  const cId = opts.customerId ?? undefined

  // Receiving products with all fields
  const fullProducts: OldProductDTO[] = await Promise.all(
    items.map(async (item) => {
      return storefrontApi.products.productById(item.product.id, cId)
    })
  ).then((products) => products.filter((p) => !!p))

  if (fullProducts.length !== items.length) {
    res.status(400).json({ error: 'Products are not found' })
    return
  }

  const fullItems: StorefrontOrderLine<OldProductDTO>[] = items.map((item, index) => ({
    ...item,
    product: fullProducts[index]
  }))

  const { data: ingridResponse, error: ingridCreateError } = await ingridApi.checkout.createSession(
    {
      purchase_country:
        opts.shippingProviderConfig?.ingridOptions?.purchaseCountry || DEFAULT_COUNTRY,
      purchase_currency:
        opts.shippingProviderConfig?.ingridOptions?.purchaseCurrency || DEFAULT_CURRENCY,
      cart: generateIngridCart(fullItems, cartDiscountCode),
      locales: [getFullLocale(locale)]
    }
  )

  if (ingridCreateError || !ingridResponse) {
    res.status(400).json({ error: ingridCreateError || 'Unknown error' })
    return
  }

  await cb(ingridResponse)
}
